async function updateLabCarrosselFlag(cnpj, enabled) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ cnpj, enabled: !!enabled }),
  };

  return fetch(
    process.env.REACT_APP_LABS_API + "OEC/laboratorio/update_lab_carrossel_flag.php",
    requestOptions
  )
    .then((response) => response.json())
    .then((json) => {
      if (json.status === 200) {
        return json;
      }
      return false;
    })
    .catch(() => false);
}

export { updateLabCarrosselFlag };
